var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_vm.loading || _vm.error ? _c('LoaderIcon', {
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [_c('div', {
    class: _vm.$style.breadcrumbs
  }, [_c('RouterLink', {
    attrs: {
      "to": {
        name: 'awards'
      }
    }
  }, [_c('MottoIcon', {
    staticClass: "cursor-pointer",
    class: _vm.$style.backButton,
    attrs: {
      "name": "Arrow",
      "icon-color": "gray"
    }
  })], 1), _c('RouterLink', {
    attrs: {
      "to": {
        name: 'awards'
      }
    }
  }, [_c('p', {
    staticClass: "p2 color-darkest-gray cursor-pointer"
  }, [_vm._v("AWARDS")])]), _c('BaseIcon', {
    staticClass: "color-gray",
    attrs: {
      "name": "chevron-right"
    }
  }), _c('p', {
    staticClass: "button-text color-primary-blue",
    class: _vm.$style.selectedBreadcrumb
  }, [_vm._v("MY AWARDS")])], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    class: _vm.$style.myAwardsContainer
  }, [_c('h2', {
    staticClass: "color-primary-blue",
    class: _vm.$style.myAwardsTitle
  }, [_vm._v(_vm._s(_vm.title))]), _vm.isMobile ? _c('div', {
    staticClass: "mb-4 d-flex"
  }, [_c('BaseSelector', {
    staticClass: "mr-15",
    attrs: {
      "active": _vm.awardType === 'User'
    },
    on: {
      "click": function click($event) {
        return _vm.pickAwardType('User');
      }
    }
  }, [_vm._v(" Individual ")]), _c('BaseSelector', {
    attrs: {
      "active": _vm.awardType === 'Office'
    },
    on: {
      "click": function click($event) {
        return _vm.pickAwardType('Office');
      }
    }
  }, [_vm._v("Office")])], 1) : _vm._e(), !_vm.getMyAwards.length ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v("You currently have no awards")]) : _vm._e(), _vm.getMyAwards.length ? _c('div', {
    class: _vm.$style.myAwards
  }, _vm._l(_vm.getMyAwards, function (award) {
    return _c('MyAward', {
      key: award.id,
      attrs: {
        "award": award
      }
    });
  }), 1) : _vm._e()]), !_vm.isMobile ? _c('div', {
    class: _vm.$style.rightPanel
  }, [_c('div', {
    staticClass: "d-flex justify-content-around"
  }, [_c('BaseSelector', {
    attrs: {
      "active": _vm.awardType === 'User',
      "data-award-select-individual": ""
    },
    on: {
      "click": function click($event) {
        return _vm.pickAwardType('User');
      }
    }
  }, [_vm._v(" Individual ")]), _c('BaseSelector', {
    attrs: {
      "active": _vm.awardType === 'Office',
      "data-award-select-office": ""
    },
    on: {
      "click": function click($event) {
        return _vm.pickAwardType('Office');
      }
    }
  }, [_vm._v(" Office ")])], 1)]) : _vm._e()])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }